export const siemDashboardMessages = {
  en: {
    siemDashboard: {
      generatorWidgetTitle: "Workflow Set Generator",
      generatorTitle: "Build your perfect",
      generatorTitleHighlight: "workflow set",
      generatorDescription:
        "Answer a few simple questions and receive workflows tailored to your needs. Efficient, individualized, and aligned with your goals.",
      learnMore: "Learn more",
      startGenerator: "Start generator",
      generatorDialogTitle: "SIEM Use Case Generator",
      learnMoreDialogTitle: "How does the workflow generator work?",
      learnMoreIntro:
        "Our workflow generator guides you through a simple but effective process to create a tailored set of SIEM use cases.",
      learnMoreStep1Title: "Infrastructure analysis",
      learnMoreStep1Text:
        "Answer targeted questions about your environment to identify relevant systems and data sources.",
      learnMoreStep2Title: "First scope and second scope",
      learnMoreStep2Text:
        "Define your priorities, from essential protections to extended security requirements.",
      learnMoreStep3Title: "Individual use cases",
      learnMoreStep3Text:
        "Based on your answers, the wizard generates a tailored preset of use cases that match your security concept.",
      close: "Close",
      imageAlt: "workflow generator",
    },
  },
  de: {
    siemDashboard: {
      generatorWidgetTitle: "Workflow Set Generator",
      generatorTitle: "Erstell dir dein perfektes",
      generatorTitleHighlight: "Set an Workflows",
      generatorDescription:
        "Beantworte ein paar einfache Fragen und erhalte automatisch perfekt auf dich zugeschnittene Workflows. Effizient, individuell und genau nach deinen Beduerfnissen.",
      learnMore: "Mehr erfahren",
      startGenerator: "Generator starten",
      generatorDialogTitle: "SIEM Use Case Generator",
      learnMoreDialogTitle: "Wie funktioniert der Workflow-Generator?",
      learnMoreIntro:
        "Unser Workflow-Generator fuehrt dich durch einen einfachen, aber effektiven Prozess, um ein perfekt abgestimmtes Set an Use Cases fuer dein SIEM zu erstellen.",
      learnMoreStep1Title: "Infrastruktur-Analyse",
      learnMoreStep1Text:
        "Beantworte gezielte Fragen zu deiner Umgebung, um relevante Systeme und Datenquellen zu identifizieren.",
      learnMoreStep2Title: "First Scope und Second Scope",
      learnMoreStep2Text:
        "Definiere deine Prioritaeten, von den essenziellen Schutzmassnahmen bis hin zu erweiterten Sicherheitsanforderungen.",
      learnMoreStep3Title: "Individuelle Use Cases",
      learnMoreStep3Text:
        "Basierend auf deinen Antworten generiert der Wizard ein massgeschneidertes Preset an Use Cases, die perfekt zu deinem Sicherheitskonzept passen.",
      close: "Schliessen",
      imageAlt: "Workflow-Generator",
    },
  },
};
